import { map } from 'lodash';
import { BaseModel } from './BaseModel';
import Section from './Section';
import LearningOutcome from './LearningOutcome';
import Post from './Post';
import Certificate from './Certificate';
import LearningUnitMember from './LearningUnitMember';
import UserRole from './UserRole';
import LearningUnitType from './LearningUnitType';
import constants from '@/constants';
import ReviewFeedback from './ReviewFeedback';
import Vimeo from './Vimeo';
import Application from './Application';
import LearningUnitOption from './LearningUnitOption';
import Category from './Category';
import PostMark from './PostMark';
import MethodComponent from './MethodComponent';
import BunnyVideo from './BunnyVideo';

function checkMemberHasRole(userId, learningUnitMembersIds = [], roleNames = []) {
  let pass = false;

  if (learningUnitMembersIds && learningUnitMembersIds.length) {
    const checkUserRoles = roleNames.map((roleName) =>
      UserRole.query().where('role', roleName).first()
    );

    if (checkUserRoles && checkUserRoles.length) {
      const checkUserRoleIds = map(checkUserRoles, 'id');

      const learningUnitMembers = learningUnitMembersIds.map((learningUnitMembersId) =>
        LearningUnitMember.find(learningUnitMembersId)
      );

      if (learningUnitMembers && learningUnitMembers.length) {
        for (let index = 0; index < learningUnitMembers.length; index++) {
          const learningUnitMember = learningUnitMembers[index];

          if (
            learningUnitMember.user.id == userId &&
            checkUserRoleIds.indexOf(learningUnitMember.user_role) !== -1
          ) {
            pass = true;

            break;
          }
        }
      }
    }
  }

  return pass;
}
export class LearningUnit extends BaseModel {
  static get entity() {
    return 'learning-units';
  }

  static get fk() {
    return 'learning_unit_id';
  }

  static get PART_DESCRIPTION_META_DATA() {
    return {
      OVERVIEW: false,
      WORK_EXAMPLE: true,
      REFLECTION: false
    };
  }

  static fields() {
    return {
      id: this.uid(),
      uid: this.attr(null),
      name: this.attr(null),
      description: this.attr(null),
      next_section: this.attr(null),
      learning_unit_type_id: this.attr(null),
      learning_unit_type: this.belongsTo(LearningUnitType, 'learning_unit_type_id'),
      number_of_online_meeting: this.attr(null),
      learning_outcome_id: this.attr(null),
      learning_outcome: this.belongsTo(LearningOutcome, 'learning_outcome_id'),
      is_published: this.attr(null),
      is_listed: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      section_ids: this.attr(null),
      sections: this.hasMany(Section, 'learning_unit_id'),
      posts_ids: this.attr(null),
      posts: this.hasMany(Post, 'learning_unit_id'),
      certificate: this.hasOne(Certificate, 'learning_unit_id'),
      learning_unit_members: this.hasManyBy(LearningUnitMember, 'learning_unit_members_ids'),
      learning_unit_members_ids: this.attr([]),
      required_review: this.boolean(false),
      submitted_review_at: this.attr(null),
      latest_request_changes_at: this.attr(null),
      what_to_do: this.attr(null),
      how_to_prepare: this.attr(null),
      who_this_for: this.attr(null),
      cover_ideas: this.attr(null),
      short_summary: this.attr(null),
      cover_image: this.attr(null),
      ultimate_learning_outcome_id: this.attr(null),
      ultimate_learning_outcome: this.belongsTo(LearningOutcome, 'ultimate_learning_outcome_id'),
      reivew_feedback_ids: this.attr(null),
      reivew_feedbacks: this.hasMany(ReviewFeedback, 'review_feedback_id'),
      properties: this.attr(null),
      media_detail_vimeo_id: this.attr(null),
      media_detail_vimeo: this.belongsTo(Vimeo, 'media_detail_vimeo_id'),
      content_media_vimeo_id: this.attr(null),
      content_media_vimeo: this.belongsTo(Vimeo, 'content_media_vimeo_id'),
      media_detail: this.attr(null),
      competency_overview: this.attr(null),
      competency_detail: this.attr(null),
      competency_how: this.attr(null),
      summary_overview: this.attr(null),
      summary_outcome: this.attr(null),
      price_verify: this.attr(null),
      price_verify_discount: this.attr(null),
      price_verify_learn: this.attr(null),
      price_verify_learn_discount: this.attr(null),
      badge_image: this.attr(null),
      content: this.attr(null),
      content_media: this.attr(null),
      developer_name: this.attr(null),
      developer_detail: this.attr(null),
      developer_media: this.attr(null),
      applications: this.hasManyBy(Application, 'application_ids'),
      application_ids: this.attr([]),
      inprogress_by_assessor_count: this.attr(null),
      method_overview: this.attr(null),
      method: this.attr(null),
      reference: this.attr(null),
      learning_resource: this.attr(null),
      how_achieve: this.attr(null),
      score_description: this.attr(null),
      open_apply_verify: this.attr(false),
      open_apply_learn: this.attr(false),
      user: this.attr(null),
      price_display: this.attr(null),
      level_type: this.attr(null),
      learning_unit_option_ids: this.attr(null),
      learning_unit_options: this.hasManyBy(LearningUnitOption, 'learning_unit_option_ids'),
      categories_ids: this.attr([]),
      categories: this.hasManyBy(Category, 'categories_ids'),
      skills: this.attr(null),
      sectorId: this.attr(null),
      sector: this.attr(null),
      skillMappingId: this.attr(null),
      tsc_order_mapping: this.attr(null),
      ccs_order_mapping: this.attr(null),
      method_components_ids: this.attr(null),
      method_components: this.hasManyBy(MethodComponent, 'method_components_ids'),
      is_payment: this.attr(false),
      original_lang: this.attr(null),
      bunny_video_id: this.attr(null),
      bunny_video: this.hasOne(BunnyVideo, 'learning_unit_id')
    };
  }

  partDescription(part) {
    let description = null;

    const { properties = {} } = this;

    if (properties && properties[`description_part_${part}`]) {
      description = properties[`description_part_${part}`];
    }

    return description;
  }

  isRecommended() {
    return this.categories_ids.some((id) => {
      const category = Category.find(id);
      return category.slug === 'recommendation';
    });
  }

  isDraft() {
    return this.is_published === false;
  }

  isOwner(userId) {
    const { learning_unit_members_ids = [] } = this;

    return checkMemberHasRole(userId, learning_unit_members_ids, [UserRole.LU_OWNER]);
  }

  isAssessor(userId) {
    const { learning_unit_members_ids = [] } = this;

    return checkMemberHasRole(userId, learning_unit_members_ids, [UserRole.LU_ASSESSOR]);
  }

  isOBEM() {
    return this.isType(constants.LEARNING_UNIT_TYPE.OBEM);
  }

  isGeneral() {
    return this.isType(constants.LEARNING_UNIT_TYPE.GENERAL);
  }

  hasUltimateLearningOutcome() {
    return this.ultimate_learning_outcome_id !== null;
  }

  isType(typeName) {
    const learningUnitTypeId = this.learning_unit_type_id;

    const learningUnitType = LearningUnitType.find(learningUnitTypeId);

    return learningUnitType ? learningUnitType.name === typeName : false;
  }

  isInstructor(userId) {
    const { learning_unit_members_ids = [] } = this;

    return checkMemberHasRole(userId, learning_unit_members_ids, [UserRole.LU_INSTRUCTOR]);
  }

  isOwnerOrInstructor(userId) {
    const { learning_unit_members_ids = [] } = this;

    return checkMemberHasRole(userId, learning_unit_members_ids, [
      UserRole.LU_OWNER,
      UserRole.LU_INSTRUCTOR
    ]);
  }

  isOwnerOrAssessor(userId) {
    const { learning_unit_members_ids = [] } = this;

    return checkMemberHasRole(userId, learning_unit_members_ids, [
      UserRole.LU_OWNER,
      UserRole.LU_ASSESSOR
    ]);
  }

  isEligibleAll(userId) {
    const { learning_unit_members_ids = [] } = this;
    // Should check with user enrollments
    return checkMemberHasRole(userId, learning_unit_members_ids, [
      UserRole.LU_OWNER,
      UserRole.LU_INSTRUCTOR,
      UserRole.LU_ASSESSOR
    ]);
  }

  canAccess(userId) {
    return this.isEligibleAll(userId);
  }

  canEdit(userId) {
    return this.isOwner(userId);
  }

  canDelete(userId) {
    return this.isOwner(userId);
  }

  getLearningProgress(userId) {
    return PostMark.calculatePostMarkedProgress(this.id, userId);
  }

  get status() {
    let status = constants.LEARNING_UNIT_STATUS.DRAFT;

    if (this.required_review) {
      status = constants.LEARNING_UNIT_STATUS.SUBMITTED_FOR_PUBLICATION;
    }

    if (this.is_published) {
      status = constants.LEARNING_UNIT_STATUS.PUBLISHED;
    }

    return status;
  }

  get skillOrderMap() {
    let { skills = null } = this;

    skills = skills ? (typeof skills == 'string' ? JSON.parse(skills) : skills) : [];

    return skills.reduce((acc, item, index) => {
      acc[item.runningId] = index;
      return acc;
    }, {});
  }

  static apiConfig = {
    actions: {
      /**
       * fetch learning unit with filter and lazy loading
       *
       * @param {Object} filter set of filter
       * @param {Number} limit
       */
      fetchWithFilter(filter, start = 0, limit = 15) {
        filter._start = start;
        filter._limit = limit;

        return this.get(`/learning-units/filter`, {
          params: filter
        });
      },
      /**
       * fetch learning unit with filter and lazy loading
       *
       * @param {Object} filter set of filter
       * @param {Number} limit
       */
      fetchExplore(filter, start = 0, limit = 15) {
        filter._start = start;
        filter._limit = limit;

        return this.get(`/learning-units/explore`, {
          params: filter
        });
      },
      fetchNonRecommended(filter = {}) {
        return this.get(
          `/learning-units/explore-non-recommended`,
          {
            params: filter
          },
          { save: false }
        );
      },
      fetchRecommended(filter = {}) {
        return this.get(
          `/learning-units/explore-recommended`,
          {
            params: filter
          },
          { save: false }
        );
      },

      /**
       * fetch all LUs with query title
       *
       * @param {String} title
       */
      fetchByTitle(title) {
        return this.get(`/learning-units?name=${title}`);
      },

      fetchByLearningUnitId(learning_unit_id) {
        return this.get(`/learning-units/${learning_unit_id}`);
      },

      fetchByAssessor(filter, start, limit) {
        filter._start = start;
        filter._limit = limit;
        return this.get('learning-units/find-by-assessor', {
          params: filter
        });
      },

      fetchByLearner(start, limit) {
        return this.get('learning-units/find-by-learner', {
          params: {
            _start: start,
            _limit: limit
          }
        });
      },

      findByDesigner(filter, start, limit) {
        filter._start = start;
        filter._limit = limit;

        return this.get('/learning-units/search-by-name', {
          params: filter
        });
      },

      fetchIsMember(filter, userId, start = 0, limit = 15) {
        filter._start = start;
        filter._limit = limit;

        return this.get(`/learning-units/members/${userId}`, {
          params: filter
        });
      },

      fetch(params = {}) {
        return this.get(`/learning-units`, {
          params
        });
      },

      fetchWithPagination(filter = {}) {
        const { _start = 0, _limit = 10 } = filter;

        return this.get(`/learning-units/filter/pagination`, {
          params: {
            ...filter,
            _start,
            _limit
          }
        });
      },
      fetchEvidenceSubmissionsWithPagination(learningUnitId, filter = {}, save = false) {
        return this.get(
          `/learning-units/${learningUnitId}/evidence-submissions/pagination`,
          {
            params: {
              ...filter
            }
          },
          { save }
        );
      },
      fetchStatusAllEvidenceSubmission(learningUnitId, filter = {}, save = false) {
        return this.get(
          `/learning-units/${learningUnitId}/evidence-submissions/status`,
          {
            params: {
              ...filter
            }
          },
          { save }
        );
      },
      fetchMethodComponents(learningUnitId) {
        return this.get(`/learning-units/${learningUnitId}/method-components`);
      },
      fetchMethodComponentsProgress(learningUnitId) {
        return this.get(`/learning-units/${learningUnitId}/method-components/progress`);
      },
      updateLearningUnit(id, body) {
        return this.put(`/learning-units/${id}`, body);
      },

      updatePriceDisplay(id, body) {
        return this.put(`/learning-units/${id}/price-display`, body);
      },

      createLearningUnit(body) {
        return this.post(`/learning-units`, body);
      },

      submitForPublication(id) {
        return this.post(`/learning-units/${id}/submit-for-publication`);
      },

      deleteLearningUnit(id) {
        return this.delete(`/learning-units/${id}`, {
          delete: id
        });
      },

      /**
       * ใช้หา conflict ระหว่าง section start_at, end_at กับ post schedule published_at
       * @param {Number} learningUnitId - learning unit's id
       * @return {Object} ex. 38, 39 คือ section id ส่วน 57, 58 เป็น post id และ conflict: false หมายถึง section นี้มี conflict
       * {
       *  "38": {
       *     "conflict": false,
       *     "post": {
       *       "57": false,
       *       "58": false
       *     }
       *   },
       *   "39": {
       *     "conflict": true,
       * *    "post": {
       *       "57": true,
       *       "58": false
       *     }
       *   },
       */
      // async getConflictBetweenSectionAndPost(learningUnitId) {
      //     const result = await this.get(
      //         `/learning-units/${learningUnitId}/post-schedule-conflict`, {
      //             save: false,
      //         }
      //     );
      //     return result.response.data;
      // },

      async getTodoAndSuggestionForPublication(learningUnitId) {
        const result = await this.get(
          `/learning-units/${learningUnitId}/todo-for-publication-and-suggestion`,
          {
            save: false
          }
        );

        return result.response.data;
      },

      async publishLearningUnit(learningUnitId) {
        return this.post(`/learning-units/${learningUnitId}/publish`);
      },

      async revertLearningUnit(learningUnitId, body = {}) {
        return this.post(`/learning-units/${learningUnitId}/revert`, body);
      },

      async checkPermissionApply(learningUnitId) {
        return this.post(`/learning-units/${learningUnitId}/permission/apply`);
      },

      checkDuplicateName(name = '') {
        return this.get(`/learning-units/check-duplicate-name?name=${name}`, { save: false });
      },

      checkMcIsDraft(learningUnitId) {
        return this.post(`/learning-units/${learningUnitId}/check-mc-is-draft`);
      },
      async fetchEvidenceSubmission(learningUnitId, params = {}) {
        const { response } = await this.get(
          `/learning-units/${learningUnitId}/evidence-submissions/pagination`,
          {
            params
          }
        );
        const data = response.data;
        return data;
      },
      async findAll(params = {}) {
        const { response } = await this.get(
          `/learning-units/all`,
          {
            params
          },
          { save: false }
        );
        const data = response.data;
        return data;
      }
    }
  };
}

export default LearningUnit;
